import React, { useEffect, useRef, useState } from "react";
import { Formik, Form } from "formik";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import Config from "../Config";
import {
    initialValues,
    getStepFields,
    step1ValidationSchema,
    step2ValidationSchema,
    step3ValidationSchema,
} from "../Components/BookingForm/Validation";

import { Container } from "../Components/BookingForm/Styles";
import StepProgress from "../Components/BookingForm/StepProgress";
import PersonalDetailsStep from "../Components/BookingForm/PersonalDetailsStep";
import AcademicDetailsStep from "../Components/BookingForm/AcademicDetailsStep";
import GuardianDetailsStep from "../Components/BookingForm/GuardianDetailsStep";
import FormNavigation from "../Components/BookingForm/FormNavigation";
import { setUrl, setUserDetails } from "../Redux/action";
import moment from "moment/moment";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

const validationSchemas = {
    1: step1ValidationSchema,
    2: step2ValidationSchema,
    3: step3ValidationSchema,
};

const StepComponents = {
    1: PersonalDetailsStep,
    2: AcademicDetailsStep,
    3: GuardianDetailsStep,
};

function BookingForm() {
    const { encryptedId: gId } = useParams();
    const [apiData, setApiData] = useState();
    const userDetails = useSelector(state => state.UserReducer.userDetails);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    // useEffect(() => {
    //     const currentUrl = window.location.href;
    //     console.log (currentUrl);
    //     dispatch(setUrl(currentUrl));
    // }, [dispatch]);

    // const gId = useSelector((state) => state.UserReducer.gId);

    const [step, setStep] = useState(1);

    const fetchFunction = async () => {
        const response = await axios.get(
            `${Config.ApiUrl}/bookings/validate/?encryptedId=${gId}`,
            {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            }
        );
        return response.data;
    };

    const getSuccess = (res) => {
        if (res.isSuccess === false) {
            dispatch(setUserDetails([]));
            navigate("/");
        }
        else {
            setApiData(res?.data);
            dispatch(setUserDetails(res?.data));
        }
    };

    const getError = (res) => {
        dispatch(setUserDetails([]));
        navigate("/");
    };

    // const {
    //     isLoading: isValidating,
    //     mutate: getListMutate,
    //     error,
    //     data,
    //     isRefetching,
    // } = useMutation(fetchFunction, {
    //     onSuccess: getSuccess,
    //     onError: getError,
    // });
    const { data, isLoading } = useQuery(
        ["bookingValidation", gId],
        fetchFunction,
        {
            enabled: !!gId,
            retry: false,
            refetchOnWindowFocus: false,
            onSuccess: getSuccess,
            onError: getError,
        }
    );

    // useEffect(() => {
    //     if (hasFetched.current) return;

    //     hasFetched.current = true;
    //     getListMutate();
    // }, []);

    const validateCurrentStep = async (values, setTouched) => {
        const fields = getStepFields(step);

        setTouched(
            fields.reduce((acc, field) => {
                acc[field] = true;
                return acc;
            }, {})
        );

        try {
            await validationSchemas[step].validate(values, {
                abortEarly: false,
            });
            return true;
        } catch {
            return false;
        }
    };

    // const bookingFormFunction = (payload) =>
    //     axios.post(`${Config.ApiUrl}/bookings/add`, payload);

    const bookingFormFunction = async (values) => {
        return await axios.post(`${Config.ApiUrl}/bookings/add`, values, {
            headers: {
                authorization: "Bearer " + userDetails?.token,
                "Content-Type": "application/json",
            },
        });
    };

    const { mutate: bookingFormMutate, isLoading: isSubmitting } = useMutation(
        bookingFormFunction,
        {
            onSuccess: ({ data }) => {
                toast.success(data?.msg || "Success");
                navigate("/success", { state: { data: data?.applicationNumber } });
            },
            onError: (error) => {
                toast.error(error?.response?.data?.msg || "Something went wrong");
            },
        }
    );

    const SubmitHandler = (values) => {
        bookingFormMutate({
            idNumber: values.studentId,
            name: values.name,
            email: values.email,
            mobile: values.phone,
            gender: values.gender,
            // dob: values.dob,
            dob: moment(values.dob, "DD-MM-YYYY").format("YYYY-MM-DD"),
            aadhaar: values.aadharNumber,
            address: values.address,
            tenure: values.academicStanding,
            institutionName: values.instituteName,
            occupation: values.occupation,
            designation: values.course,
            domain: values.stream,
            intakeDate: values.intakeDate,
            fatherName: values.fatherName,
            fatherMobile: values.fatherPhone,
            fatherEmail: values.fatherEmail,
            ...(values.motherName && { motherName: values.motherName }),
            ...(values.motherPhone && { motherMobile: values.motherPhone }),
            ...(values.motherEmail && { motherEmail: values.motherEmail }),

            ...(values.guardianName && { localGuardianName: values.guardianName }),
            ...(values.guardianRelation && { localGuardianRelation: values.guardianRelation }),
            ...(values.guardianPhone && { localGuardianMobile: values.guardianPhone }),
            ...(values.guardianEmail && { localGuardianEmail: values.guardianEmail }),
            // motherName: values.motherName,
            // motherMobile: values.motherPhone,
            // motherEmail: values.motherEmail,
            // localGuardianName: values.guardianName,
            // localGuardianRelation: values.guardianRelation,
            // localGuardianMobile: values.guardianPhone,
            // localGuardianEmail: values.guardianEmail,
            encryptedId: gId
        });
    };

    if (isLoading) {
        return (
            <Container>
                <div className="flex min-h-[60vh] items-center justify-center">
                    <div className="flex flex-col items-center gap-3">
                        <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-200 border-t-blue-600"></div>
                        <p className="text-sm text-gray-500">
                            Loading booking details...
                        </p>
                    </div>
                </div>
            </Container>
        );
    }

    return (
        <Container>

            {/* <BookingHeader /> */}
            <StepProgress currentStep={step} />
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchemas[step]}
                validateOnBlur
                validateOnChange
                onSubmit={(values) => SubmitHandler(values)}
            >
                {({
                    errors,
                    touched,
                    values,
                    setFieldValue,
                    setTouched,
                    submitForm,
                }) => {
                    const StepComponent = StepComponents[step];

                    const handleNext = async () => {
                        const isValid = await validateCurrentStep(values, setTouched);

                        if (!isValid) return;

                        if (step === 3) {
                            submitForm();
                        } else {
                            setStep((prev) => prev + 1);
                            window.scrollTo({
                                top: 0,
                                behavior: "smooth",
                            });
                        }
                    };

                    return (
                        <Form>
                            <StepComponent
                                errors={errors}
                                touched={touched}
                                values={values}
                                setFieldValue={setFieldValue}
                            />

                            <FormNavigation
                                currentStep={step}
                                isSubmitting={isLoading}
                                onPrev={() => {
                                    setStep((prev) => prev - 1);
                                    window.scrollTo({
                                        top: 0,
                                        behavior: "smooth",
                                    });
                                }}
                                onNext={handleNext}
                            />
                        </Form>
                    );
                }}
            </Formik>
        </Container>
    );
}


function BookingHeader() {
    return (
        <div className="bg-white border border-gray-200 rounded-xl p-5 mb-5">
            <h1 className="text-2xl font-semibold text-gray-900">
                XYZ PG & Coliving
            </h1>

            <p className="text-sm text-gray-500 mt-1">
                Complete your booking by providing your details.
            </p>
        </div>
    );
}

export default BookingForm;
